import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrivacyPolicyViewer } from '../../components/legal/PrivacyPolicyViewer';
import PublicNavBar from '../../components/layout/PublicNavBar';

export const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation('auth');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <PublicNavBar />

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <PrivacyPolicyViewer mode="page" />
          
          {/* Back to Home */}
          <div className="mt-8 pt-8 border-t">
            <Link
              to="/"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              ← {t('auth:backToSignIn')}
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center text-sm text-gray-600">
            <p>© 2025 MatchGo. All rights reserved.</p>
            <div className="mt-2 space-x-4">
              <Link to="/legal/terms-of-service" className="hover:text-primary-600">
                {t('auth:termsOfService')}
              </Link>
              <span>|</span>
              <Link to="/legal/privacy-policy" className="hover:text-primary-600">
                {t('auth:privacyPolicy')}
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
